import React, { useEffect } from "react";

// import './style.css'

import { useSelector, useDispatch } from 'react-redux';
import { getSearchClear, getSearchIdle } from "../../modules/search/actions";

const Modal = (props) => {
    
    const dispatch = useDispatch();

    const { header, content, dopClass, show, toggle, callbackClose, footer, load, loadPreview } = props;

    const statusSearch = useSelector(state => state.search.status);
    const theme = useSelector((state) => state.initData.theme);

    useEffect(() => {
        if(show){
            document.body.classList.add('_hidden');
        } else {
            document.body.classList.remove('_hidden');
        }
    }, [show])

    const handleClose = (e) => {
        e.preventDefault();

        toggle(!show);

        if(callbackClose){
            callbackClose();
        }

        dispatch(getSearchClear());

    } 

    return (
        <div className={`modal _default ${dopClass} ${show && '_active' || ''}`}>
            <div className="modal__bg" onClick={handleClose}></div>
            {((theme == 'dark' || theme == 'light') && load && (
                <div className="modal__load">{loadPreview}</div>
            )) || (
                <div className="modal__wrap">
                    <div className="modal__header">
                        {dopClass !== '_sale' && (
                            <a href="#" className="modal__back" onClick={handleClose}>
                                {(theme == 'light' || theme == 'dark') && (
                                    <>
                                        {dopClass == '_search' && (
                                            <>Отменить</>
                                        )}
                                        {dopClass == '_filter' && (
                                            <>
                                                <svg
                                                    width="18"
                                                    height="18"
                                                    viewBox="0 0 18 18"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        fillRule="evenodd"
                                                        clipRule="evenodd"
                                                        d="M11.25 16.5L3.75 9L11.25 1.5L13.125 3.375L7.5 9L13.125 14.625L11.25 16.5Z"
                                                        fill="#0F0F0F"
                                                    />
                                                </svg>
                                                Назад
                                            </>
                                        )}
                                    </>
                                ) || (
                                    <img src="https://cdn.podeli.ru/web-catalog/assets/img/icon-back.svg" />                                
                                )}
                            </a>
                        )}
                        {header}
                    </div>
                    <div className="modal__content">
                        {content}
                    </div>
                    {footer && (
                        <div className="modal__footer">
                            {footer}
                        </div>
                    )}
                </div>
            )}
        </div>
    )
}

export default Modal;